import { Checkbox, Col, Row, Input, Select } from "antd";
import React from "react";
import "./rentals.scss";
import { rentalDrivingExperience } from "../../contants/variables";

const RentalRequirements = (props) => {
  const { form, onCheckboxChange, handleFieldChange, handleDropdownChange } =
    props;

  return (
    <Row gutter={[10, 10]}>
      <Col span={8}>
        <div className="form-fields" style={{ margin: "20px 0px 0" }}>
          <Checkbox
            valuePropName="checked"
            checked={form.allowedPPlate}
            onChange={(e) => onCheckboxChange("allowedPPlate", e)}
          >
            P-Plate Drivers Allowed
          </Checkbox>
        </div>
      </Col>
      {/* <Col span={6}>
                <div className='form-fields' style={{margin:"20px 0px 0"}}>
                    <Checkbox
                        valuePropName="checked"
                        checked={form.allowedDriveToMalaysia}
                        onChange={(e)=>onCheckboxChange('allowedDriveToMalaysia',e)}
                    >
                        Drive to Malaysia
                    </Checkbox>
                </div>
            </Col> */}
      <Col span={8}>
        <div className="form-fields" style={{ margin: "20px 0px 0" }}>
          <Checkbox
            valuePropName="checked"
            checked={form.zeroDeposit}
            onChange={(e) => onCheckboxChange("zeroDeposit", e)}
          >
            S$ 0 Deposit
          </Checkbox>
        </div>
      </Col>
      <Col span={8}>
        <div className="form-fields" style={{ margin: "20px 0px 0" }}>
          <Checkbox
            valuePropName="checked"
            checked={form.allowed21yrOld}
            onChange={(e) => onCheckboxChange("allowed21yrOld", e)}
          >
            Below 21-Year Old Allowed
          </Checkbox>
        </div>
      </Col>
      <Col span={8}>
        <div className="form-fields">
          <p className="form-field-label">Driving Experience : </p>
          <Select
            showSearch
            value={form.drivingExperience || undefined}
            onChange={(value) =>
              handleDropdownChange("drivingExperience", value)
            }
            style={{ width: "100%" }}
            placeholder="Search to Select."
            // optionFilterProp="children"
            // filterOption={(input, option) =>
            // option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            // }
            // filterSort={(optionA, optionB) =>
            // optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
            // }
          >
            {rentalDrivingExperience.map((exp, i) => (
              <Select.Option key={i} value={exp}>
                {exp} Year
              </Select.Option>
            ))}
          </Select>
          {/* <Input
                        value={form.drivingExperience}
                        onChange={text=>handleFieldChange('drivingExperience' , text)}
                    /> */}
        </div>
      </Col>
    </Row>
  );
};

export default RentalRequirements;
